module.exports = __webpack_public_path__ + "static/media/Telegram.cd913545.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/Telegram.svg
// module id = 310
// module chunks = 0